
import React from "react";
import { Button } from "@/components/ui/button";
import { BrainCircuit } from "lucide-react";

interface CognitiveInsightsButtonProps {
  showInsights: boolean;
  hasEnoughData: boolean;
  onToggle: () => void;
}

const CognitiveInsightsButton: React.FC<CognitiveInsightsButtonProps> = ({
  showInsights,
  hasEnoughData,
  onToggle,
}) => {
  if (!hasEnoughData) return null;

  return (
    <Button
      variant="outline"
      onClick={onToggle}
      className="mb-4 bg-indigo-50 text-indigo-600 border-indigo-200 hover:bg-indigo-100 hover:text-indigo-700"
      size="sm"
    >
      <BrainCircuit className="h-4 w-4 mr-2" />
      {showInsights ? "Hide Focus Analytics" : "Show Focus Analytics"}
    </Button>
  );
};

export default CognitiveInsightsButton;
